import { useCallback, useEffect, useState } from "react";
import { CalConnectedCalendarsResponse } from "@/types/calendar";
import { useCalApi } from "./useCalApi";

type UseConnectedCalendarsResult = {
  isLoading: boolean;
  data: CalConnectedCalendarsResponse | null;
  refetch: () => Promise<void>;
};

/**
 * Hook to fetch connected calendars for the current user.
 * Replaces @calcom/atoms useConnectedCalendars hook.
 */
export function useConnectedCalendars(): UseConnectedCalendarsResult {
  const { fetchCalApi } = useCalApi();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<CalConnectedCalendarsResponse | null>(null);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await fetchCalApi<CalConnectedCalendarsResponse>("/calendars");
      setData(result);
    } finally {
      setIsLoading(false);
    }
  }, [fetchCalApi]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    isLoading,
    data,
    refetch: fetchData,
  };
}
